import DocumentCreationButton from 'Components/DocumentCreationButton';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatPartialDate } from 'Utility/date';

const FVC = ({ documents, startEdit }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id={'clinicalstudy.fvc'} />}
      newButton={
        <DocumentCreationButton
          name="fvc"
          text={'clinicalstudy.newfvc'}
          onClick={startEdit({}, 'fvc')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>
              <FormattedMessage id={'general.date'} />
            </Item>
            <Item xs={2}>
              <FormattedMessage id={'clinicalstudy.litrePlaceholder'} />
            </Item>
            <Item xs={2}>
              <FormattedMessage id={'clinicalstudy.fvcPredictedPercentage'} />
            </Item>
            <Item xs={6}>
              <FormattedMessage id={'clinicalstudy.sitOrLieDown'} />
            </Item>
          </>
        }
        contentFormat={d => (
          <>
            <Item xs={2} style={{ fontWeight: '600' }}>
              {formatPartialDate(d.date)}
            </Item>
            <Item xs={2}>{d.litres ?? '-'}</Item>
            <Item xs={2}>{d.predicted ?? '-'}</Item>
            <Item xs={3}>
              {d.sittingOrLyingDown ? <FormattedMessage id={'clinicalstudy.opts.' + d.sittingOrLyingDown} /> : '-'}
            </Item>
            <Item xs={3}>
              <HistoryRowControls document={d} startEdit={startEdit} />
            </Item>
          </>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'fvc'>[];
  startEdit: StartEdit;
}

export default FVC;
